import { startOfDay } from "date-fns";

// Drives the per-chart "Earliest data" pill when data starts after the range anchor.
export interface EffectiveWindow {
  earliestDataDate: Date;
  // False when data begins before the visible window (anchor is off-screen).
  dataStartsInWindow: boolean;
}

interface EffectiveWindowInput {
  firstDataDate?: Date;
  // Gap vs pre-order anchor: data must start after publication when known.
  publishedAt?: Date | null;
  selectedStart?: Date;
  selectedEnd?: Date;
}

// Partial-history metadata for the pill; null when empty state covers it or range is fully covered.
export const getEffectiveWindow = ({
  firstDataDate,
  publishedAt,
  selectedStart,
  selectedEnd,
}: EffectiveWindowInput): EffectiveWindow | null => {
  if (!firstDataDate || !selectedStart || !selectedEnd) {
    return null;
  }

  const start = startOfDay(selectedStart);
  const end = startOfDay(selectedEnd);
  const earliest = startOfDay(firstDataDate);

  if (earliest > end) {
    return null;
  }

  const published = publishedAt ? startOfDay(publishedAt) : undefined;
  const isPartialHistory = published ? earliest > published : earliest > start;
  if (!isPartialHistory) {
    return null;
  }

  return {
    earliestDataDate: earliest,
    dataStartsInWindow: earliest >= start,
  };
};
